import _extends from "@babel/runtime/helpers/extends";
import { Box } from '@wix/design-system';
import { ConfirmSmall } from '@wix/wix-ui-icons-common';
import React, { useCallback } from 'react';
import { IssueBadge } from '../../../issue-badge';
import { CardListItem } from '../../core/custom-collapse-list-item/card-collapse-list-item';
export const A11yCollapsibleCard = /*#__PURE__*/React.memo(_ref => {
  let {
    badgeText,
    badgeTooltipContent,
    onBadgeTooltipShow,
    showBadge = true,
    issueCount,
    suffix,
    children,
    isLoading,
    isFailed,
    disabled,
    ...rest
  } = _ref;
  const renderSuffix = useCallback(() => {
    return /*#__PURE__*/React.createElement(Box, {
      direction: "horizontal",
      gap: "SP1",
      verticalAlign: "middle"
    }, showBadge ? !isFailed && issueCount === 0 ? /*#__PURE__*/React.createElement(Box, {
      color: "G10",
      height: 18,
      verticalAlign: "middle",
      width: 18
    }, /*#__PURE__*/React.createElement(ConfirmSmall, null)) : badgeText && /*#__PURE__*/React.createElement(IssueBadge, {
      badgeSize: "tiny",
      label: badgeText,
      tooltipContent: badgeTooltipContent,
      tooltipEnterDelay: 200,
      onTooltipShow: onBadgeTooltipShow
    }) : null, suffix);
  }, [issueCount, badgeText, badgeTooltipContent, onBadgeTooltipShow, suffix, showBadge, isFailed]);
  return /*#__PURE__*/React.createElement(CardListItem, _extends({
    disabled: disabled || isLoading,
    stickyHeader: true,
    suffix: renderSuffix(),
    variant: "collapsible"
  }, rest), children);
});
//# sourceMappingURL=a11y-collapsible-card.js.map